import { IRouteEntityAttributes, RouteEntity } from 'Models/Entities';
import { wizardModeOptions } from 'Models/Enums';
import { isNotNullOrUndefined, isNullOrUndefined } from 'Util/TypeGuards';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { DateRangePicker } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Sidebar/FerryFilters/TripDetails/DateRangePicker';
import { TripTypeButtons } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Sidebar/FerryFilters/TripDetails/TripTypeButtons';
import TripSelector from 'Views/Components/_HumanWritten/TripSelector/TripSelector';

export interface TripDetailsModel {
	tripTypeTabSelected: 'one way' | 'return';
	endDate: Date;
	fromLocation: string;
	toLocation: string;
	startDate: Date;
	route: RouteEntity | IRouteEntityAttributes;
	wizardData: BookingWizardData;
}

export interface TripDetailsProps {
	model: TripDetailsModel;
	onTabSelected: (direction: 'one way' | 'return') => void;
	typeSelected: string;
	onDatesChanged: (startDate: Date, departureDate: boolean, updateOtherDate: boolean) => void;
	onUpdateRouteDetails: (fromLocation: string, toLocation: string, route: RouteEntity) => void;
	departureTrip: boolean | undefined;
	hideTripTypeButtons?: boolean;
	hideDateRangePicker?: boolean;
}

export function TripDetails({
	model,
	onTabSelected,
	typeSelected,
	onDatesChanged,
	onUpdateRouteDetails,
	departureTrip,
	hideTripTypeButtons,
	hideDateRangePicker,
}: TripDetailsProps) {
	const changeBothDates = isNullOrUndefined(departureTrip);

	return (
		<div className="trip-details__container">
			{!hideTripTypeButtons && (
				<TripTypeButtons typeSelected={typeSelected} onTabSelected={onTabSelected} model={model} />
			)}
			<TripSelector
				startLocationId={model.fromLocation}
				endLocationId={model.toLocation}
				setLocations={({ startLocationId, endLocationId }) => {
					onUpdateRouteDetails(startLocationId, endLocationId, new RouteEntity());
				}}
				// While editing an existing booking the route can now be changed, except on a
				// discounted booking or one that has started check-in — see
				// getJourneyChangeBlockedReason, which the edit modal reads too so the option list
				// and this control cannot disagree. The backend enforces the same rule in
				// DetectJourneyChangeStep.
				disabled={
					model.wizardData.wizardMode === wizardModeOptions.ALTERATION &&
					isNotNullOrUndefined(model.wizardData.journeyChangeBlockedReason)
				}
			/>
			{!hideDateRangePicker && (
				<DateRangePicker
					model={model}
					onDatesChanged={onDatesChanged}
					changeBothDates={changeBothDates}
					departureTrip={departureTrip}
				/>
			)}
		</div>
	);
}
